import { l10n } from '@ott/l10n';

import BaseTravellersChildren from '@ott/travellers-children';

class TravellersChildren extends BaseTravellersChildren {
  renderAgeText(age) {
    if (+age === 0) {
      return l10n('travellersControl.infantAge');
    }

    return `${age} ${l10n('searchForm.agesChildren', { value: age })}`;
  }

  renderSelectedAgeText(age) {
    if (+age === 0) {
      return l10n('travellersControl.infant');
    }

    return `${l10n('travellersControl.child')}, ${this.renderAgeText(age)}`;
  }
}

export default TravellersChildren;
